<template>
  <div>
    <p class="title is-3-desktop is-4-tablet is-5-mobile">
      Bandeja Digitalización
    </p>

    <section>
      <div  class="block">
       <b-field grouped>


        <b-input placeholder="código barras.."  v-model="textSearch"  type="search" icon="magnify">
        </b-input>

        <b-input :disabled="!textSearch" placeholder="Identificador Único"  v-model="identificador"  type="search" icon="magnify">
        </b-input>

        <b-input :disabled="!textSearch" placeholder="N° Documento.."  v-model="nroDocumento"  type="search" icon="magnify">
        </b-input>




        <p class="control">
          <b-tooltip label="Ingrese un mínimo de 2 caracteres"
                     position="is-bottom">

            <button v-if="consultaBandeja.bandeja==='DIGITALIZACION'" @click="loadItemMateriales" class="button is-info">Buscar</button>

            <button v-if="consultaBandeja.bandeja!=='DIGITALIZACION'"  @click="buscarRegistroPorCodigo" class="button is-info">Buscar</button>

          </b-tooltip>
        </p>
      </b-field>

      </div>
    </section>

    <section style="margin-top: 15px">
      <b-table
        :data="registros.content"
        paginated
        backend-pagination
        :total="registros.totalElements"
        :per-page="searchOptions.perPage"
        @page-change="onPageChange"
        :current-page="searchOptions.pageNumber"
      >
        <template slot-scope="props">
          <b-table-column label="#"  class="is-size-7">
          {{ getrowIndex(props.index)+1 }}
          </b-table-column>

          <b-table-column label="Sistema Registro"  class="is-size-7">
            {{ props.row.sistemaRegistro }}
          </b-table-column>

          <b-table-column label="Transacción"  class="is-size-7">
            {{ props.row.transaccion }}
          </b-table-column>

          <b-table-column label="Tipo Transacción"  class="is-size-7">
            {{ props.row.tipoTransaccion }}
          </b-table-column>

          <b-table-column label="Tipo Documento"  class="is-size-7">
            {{ props.row.tipoDocumento }}
          </b-table-column>

          <b-table-column label="N° Documento"  class="is-size-7">
            {{ props.row.nroDocumento }}
          </b-table-column>

          <b-table-column label="Fecha de Transacción"  class="is-size-7">
            {{ props.row.fechaTransaccion }}
          </b-table-column>

          <b-table-column label="Identificador Único"  class="is-size-7">
            {{ props.row.identificador }}
          </b-table-column>

          <b-table-column label="Telefono/Celular"  class="is-size-7">
            {{ props.row.telefonoCelular }}
          </b-table-column>

          <b-table-column label="Digitalizar"  class="is-size-7">
            {{ props.row.digitalizar }}
          </b-table-column>

          <b-table-column label="Validación"  class="is-size-7">
            {{ props.row.validacion }}
          </b-table-column>

          <b-table-column label="Código Oficina"  class="is-size-7">
            {{ props.row.address.code }}
          </b-table-column>

          <b-table-column label="Nombre Oficina"  class="is-size-7">
            {{ props.row.address.name }}
          </b-table-column>


          <b-table-column label="Estado"  class="is-size-7">
            <b-field >
            <b-select @input="actualizarEstado(props.row)" v-model="props.row.estado"  placeholder="Seleccione estado" rounded>
                <option value="FALTANTE">Faltante</option>
                <option value="OK">Ok</option>
            </b-select>
        </b-field>
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large"> </b-icon>
              </p>
              <p>No hay registros</p>
            </div>
          </section>
        </template>

        <template #footer>
          <div class="has-text-centered ">
            <button :disabled="!registros.totalElements>0 || !habilitarButtonBandeja"
              class="button is-info is-rounded"
              @click="sendBandejaCustodiaDialog"
              type="button"
            >
              Terminar Digitalización
            </button>
          </div>
        </template>

      </b-table>
    </section>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Util from "../util";
import ImportarArchivo from "./modal/ImportarArchivo";

import SociosApi from "../api/modules/SociosApi";

export default {
  data() {
    return {
      textSearch:null,
      nroDocumento: '',
      identificador: '',
      sistemaRegistros: [],
      registros: [],
      searchOptions: {
        perPage: 10,
        pageNumber: 1,
      },
      habilitarButtonBandeja:true,
      consultaBandeja:{}
    };
  },
  methods: {


    onPageChange(page) {
      this.searchOptions.pageNumber = page;
      this.loadItemMateriales().then();
    },

    buscarRegistroPorCodigo(){

      const params = [
        `codigo=${this.textSearch.trim()}`,
      ].join("&")

      return new Promise((resolve, reject) => {
        SociosApi.getitemmaterialBycode(this, {
          idClient: this.getClient.id,
          param: params,
        })
          .then((data) => {
           this.consultaBandeja=data;
            this.$toast.open({duration: 3000,message:`Se encontró ${data.cantidadregistro} registros correctamente en la bandeja de ${data.bandeja}`, type:'is-success'});
            if(data.bandeja==='DIGITALIZACION'){
              this.loadItemMateriales();
            }

            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    loadItemMateriales() {
      let arrayparams = [
        `codigo=${this.textSearch.trim()}`,
        `pageNumber=${this.searchOptions.pageNumber}`,
        `perPage=${this.searchOptions.perPage}`,
      ]

      if(this.identificador){
         arrayparams.push(`identificador=${this.identificador.trim()}`);
      }

      if(this.nroDocumento){
      arrayparams.push(`nroDocumento=${this.nroDocumento.trim()}`);
      }
    const params=arrayparams.join("&");


      return new Promise((resolve, reject) => {
        SociosApi.getItemMaterialesBandejaDigitlaizacion(this, {
          idClient: this.getClient.id,
          param: params,
        })
          .then((data) => {
            this.registros = data.listado;
            this.habilitarButtonBandeja=data.listaValido;
            // this.validateRegistros();
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },


    actualizarEstado(item){
      return new Promise((resolve, reject) => {
      SociosApi.actualizarItemMaterialEstado(this, {
          itemMaterial: item,
        })
          .then((data) => {
            // this.registros = data;
            this.loadItemMateriales();
            this.$toast.open({duration: 1000,message:"Se actualizó correctamente el estado", type:'is-success'});
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    //  validateRegistros(){
    //   let registroSocios=this.registros.content;
    //   for (let index = 0; index < registroSocios.length; index++) {
    //     const element = registroSocios[index].estado;
    //     if(element){
    //       this.habilitarButtonBandeja=false;
    //     }else{
    //       this.habilitarButtonBandeja=true;
    //       break;
    //     }
    //   }
    // },

    sendBandejaCustodiaDialog(){
          this.$dialog.confirm({
          title: 'Enviar Bandeja Custodia',
          message: 'Está seguro que desea enviar los registros a la Bandeja de Custodia?',
          confirmText: 'Si',
          cancelText: 'No',
          type: 'is-success',
          hasIcon: true,
          onConfirm: () => {
            this.sendBandejaCustodia()
          }
        })

    },

    sendBandejaCustodia() {
      let idMaterial =this.registros.content[0].idMaterial;
      return new Promise((resolve, reject) => {
        SociosApi.enviarBandejaDigitalizacion(this, {
          idClient: this.getClient.id,
          idMaterial: idMaterial,
        })
          .then((data) => {
            if (data) {
             this.$toast.open({duration: 5000,message:"Se envió correctamente a la bandeja de Custodia", type:'is-success'});
              this.loadItemMateriales().then();
            }
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

   getrowIndex(item) {
      let contador=(this.searchOptions.pageNumber-1)*this.searchOptions.perPage
      return contador+item;
    }

  },
  computed: {
    ...mapGetters({
      getClient: "auth/getClient",
    }),

  },

  mounted() {},

  created() {

  },
};
</script>




// WEBPACK FOOTER //
// src/components/BandejaDigitalizacion.vue